import script from "./ProductsDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductsDetail.vue?vue&type=script&setup=true&lang=js"

import "./ProductsDetail.vue?vue&type=style&index=0&id=5e257300&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e257300"]])

export default __exports__